import { connect } from 'react-redux';
import Results from './Results';

import { getAnnualResults } from './selectors';
import { setSystemProduction } from './actions';

const mapStateToProps = state => ({
    annualResults: getAnnualResults(state),
    selectedFinancing: state.settings.selectedFinancing,
    doughnutSlider: state.settings.doughnutSlider,
    annualMonth: state.settings.annualMonth,
});

const combinedActions = {
    setSystemProduction,
};

export default connect(mapStateToProps, combinedActions)(Results);



// WEBPACK FOOTER //
// ./src/containers/Simulator/TabBar/Results/index.js